module.exports = __webpack_public_path__ + "static/img/img3.2846eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202210/img3.png
// module id = B34F
// module chunks = 0